import { AppPageRoutesWithTelemetry } from '@ms/yammer-page-route-telemetry';
import type { FC } from 'react';
import React from 'react';

import { pageRoutes } from './loadablePageRoutes';

const Routes: FC = () => <AppPageRoutesWithTelemetry routes={pageRoutes} />;

export default Routes;
